<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>打印配置</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddFeePrintSpecModal">
          <i class="el-icon-plus"></i>添加
        </el-button>
      </div>

      <el-table :data="feePrintSpecManageInfo.feePrintSpecs" style="width: 100%" border>
        <el-table-column prop="printId" label="编码" align="center" />
        <el-table-column prop="printName" label="名称" align="center" />
        <el-table-column label="规格" align="center">
          <template slot-scope="scope">
            {{ scope.row.specCd == '1010' ? '催缴打印说明' : '收据打印说明' }}
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image :src="scope.row.qrImg" style="border-radius: 5px;" :preview-src-list="[scope.row.qrImg]"
              fit="cover" :style="{ width: '100px', height: '100px' }"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_openEditFeePrintSpecModel(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="_openDeleteFeePrintSpecModel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @current-change="handlePageChange" :current-page="feePrintSpecManageInfo.conditions.page"
        :page-size="feePrintSpecManageInfo.conditions.row" layout="total, prev, pager, next"
        :total="feePrintSpecManageInfo.total" style="margin-top: 20px; text-align: right;"></el-pagination>
    </el-card>

    <add-fee-print-spec ref="addFeePrintSpec" @refresh="_listFeePrintSpecs" />
    <edit-fee-print-spec ref="editFeePrintSpec" @refresh="_listFeePrintSpecs" />
    <delete-fee-print-spec ref="deleteFeePrintSpec" @refresh="_listFeePrintSpecs" />
  </div>
</template>

<script>
import { getFeePrintSpecList } from '@/api/goods/feePrintSpecApi'
import { getShopId } from '@/api/shop/shopApi'
import AddFeePrintSpec from '@/components/goods/addFeePrintSpec'
import EditFeePrintSpec from '@/components/goods/editFeePrintSpec'
import DeleteFeePrintSpec from '@/components/goods/deleteFeePrintSpec'

export default {
  name: 'FeePrintSpecManage',
  components: {
    AddFeePrintSpec,
    EditFeePrintSpec,
    DeleteFeePrintSpec
  },
  data() {
    return {
      feePrintSpecManageInfo: {
        feePrintSpecs: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          specCd: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.feePrintSpecManageInfo.conditions.shopId = getShopId()
    this._listFeePrintSpecs()
    console.log(this.feePrintSpecManageInfo.moreCondition)
  },
  methods: {
    async _listFeePrintSpecs(page = 1, rows = 10) {
      this.feePrintSpecManageInfo.conditions.page = page
      this.feePrintSpecManageInfo.conditions.row = rows
      try {
        const res = await getFeePrintSpecList(this.feePrintSpecManageInfo.conditions)
        this.feePrintSpecManageInfo.feePrintSpecs = res.data
        this.feePrintSpecManageInfo.total = res.total
        this.feePrintSpecManageInfo.records = res.records
      } catch (error) {
        console.error(error)
      }
    },
    handlePageChange(val) {
      this._listFeePrintSpecs(val, this.feePrintSpecManageInfo.conditions.row)
    },
    _openAddFeePrintSpecModal() {
      this.$refs.addFeePrintSpec.open()
    },
    _openEditFeePrintSpecModel(row) {
      this.$refs.editFeePrintSpec.open(row)
    },
    _openDeleteFeePrintSpecModel(row) {
      this.$refs.deleteFeePrintSpec.open(row)
    },
    _queryFeePrintSpecMethod() {
      this._listFeePrintSpecs()
    },
    _moreCondition() {
      this.feePrintSpecManageInfo.moreCondition = !this.feePrintSpecManageInfo.moreCondition
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
}
</style>